import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { Button, Haldor__Block__Plugin, Flex } from '@haldor/ui';
import { ASSESSMENT_TYPES } from '../AssessmentTypes';

var AddTeacherAssessmentBlockButton_Plugin = /*#__PURE__*/function (_Haldor__Block__Plugi) {
  _inherits(AddTeacherAssessmentBlockButton_Plugin, _Haldor__Block__Plugi);

  var _super = _createSuper(AddTeacherAssessmentBlockButton_Plugin);

  function AddTeacherAssessmentBlockButton_Plugin(props) {
    var _this;

    _classCallCheck(this, AddTeacherAssessmentBlockButton_Plugin);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onButtonPress", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(type, event) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                event.preventDefault();
                _context.next = 3;
                return _this.editor.addBlock('Haldor.Blocks.AssessmentBlock');

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "init", function () {
      var _assertThisInitialize = _assertThisInitialized(_this),
          editor = _assertThisInitialize.editor;

      var translate = editor.getProp('translate');
      editor.renderer.registerPosition('after_blocks', function () {
        return /*#__PURE__*/React.createElement("div", {
          className: "add-assessment-button"
        }, /*#__PURE__*/React.createElement(Flex, {
          center: true
        }, /*#__PURE__*/React.createElement(Button, {
          onClick: function onClick(e) {
            _this.onButtonPress(ASSESSMENT_TYPES.TEACHER, e);
          },
          type: "secondary",
          style: {
            marginRight: '.55rem'
          }
        }, translate('Add teacher assessment'))));
      });
    });

    _this.name = 'AddAssessmentBlockButton_Plugin';
    return _this;
  }

  return _createClass(AddTeacherAssessmentBlockButton_Plugin);
}(Haldor__Block__Plugin);

export default AddTeacherAssessmentBlockButton_Plugin;